// @ts-nocheck
/* eslint-disable */
export const llaPlatformArrowSouthEastIcon = {
    data: `<svg viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.03003 0.72998L9.30005 9.00977" stroke="currentColor" stroke-miterlimit="10" stroke-linecap="round"/><path d="M3.65002 9.00977H9.30005V3.3501" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/></svg>`,
    name: 'arrow-south-east' as const
};